<canvas #palette style="background:white;display: none" class='center'></canvas>
<canvas #chooser class='center'></canvas>
